export { default } from './Lozenge'
